/*
   Journey Step

   Show the art available for the given step
   Show the relative blurb for this step
   Allow the user to click on an art piece and show the selection modal
   Upon selection of the art piece, set the state and move to the next step

   http://jsfiddle.net/ThiefMaster/LPh33/4/
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { 
  currentJourneyStepProgress,
  journeyStepIdsForCurrentJourney
} from '../../selectors/journeyState-selectors'
import { setSelectedArtwork, setArtworkForModal } from '../../actions/artwork-actions'
import { setJourneyProgressStep } from '../../actions/journey-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';

import '../../css/JourneyStep.css'

/*
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
} */

class Artwork extends React.Component {
   render() {
      const { artwork, currentJourneyStep, index, galleryId, setArtworkForModal } = this.props
      const r = (index % 10) // always generate the same random class
      const d = (index % 6)
      return (
        <div style={this.props.style} 
        key={`${currentJourneyStep}-${artwork.id}`}
        className={`artwork-container artwork-${index} delay-${d}`}>
            <Hammer onTap={() => setArtworkForModal(galleryId, artwork.get('id'))} options={tapOptions} >
               <img 
                  key={`${currentJourneyStep}-${artwork.id}`} 
                 className={`thumbnail ${artwork.get('orientation')} rotate-${r}`} 
                   src={artwork.getIn(['artwork', 'medium', 'url'])} 
                  alt={`artwork ${artwork.name}`}
                  draggable={false}
               />
            </Hammer>
        </div>
      );
   }
}

const mapStateToProps = (state, ownProps) => {
  return {
   currentJourneyStep: currentJourneyStepProgress(state, ownProps),
   journeyStepIds: journeyStepIdsForCurrentJourney(state, ownProps),
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
   setSelectedArtwork,
   setJourneyProgressStep,
   setArtworkForModal
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Artwork)


// WEBPACK FOOTER //
// ./src/components/JourneyStep/Artwork.js